"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=event-artist.js.map